export default __webpack_public_path__ + "static/media/filter-plus-icon.e63bb902.svg";